/** Personal signature settings share their connected body with administrator mailbox settings. */
import { useI18n } from '@platform/i18n';
import { breadcrumbFor, localizeRegistry, MailboxSignaturesBody, PageBody, PageHeader, type MailboxSignatureAdapter } from '@platform/ui';
import { useLocation } from 'react-router';
import { api } from '../api';
import { useMail } from '../mail-context';
import { webmailNavigation } from '../navigation';
import { SettingsTabs } from './settings-tabs';

const adapter: MailboxSignatureAdapter = {
  load: () => api.mySignatures(),
  get: (id) => api.mySignature(id),
  create: (input) => api.createSignature(input),
  update: (id, input) => api.updateSignature(id, input),
  remove: (id) => api.deleteSignature(id),
  setDefaults: (defaults) => api.setSignatureDefaults(defaults),
};
export function SettingsPage() {
  const { t } = useI18n();
  const { pathname } = useLocation();
  const { reloadSignatures } = useMail();
  return <div className="min-h-0 flex-1 overflow-y-auto">
    <PageHeader breadcrumb={breadcrumbFor(localizeRegistry(webmailNavigation, t), pathname)} title={t('webmail.signatures.title')} description={t('webmail.signatures.description')} tabs={<SettingsTabs active="signatures" />} />
    <PageBody width="form"><MailboxSignaturesBody adapter={adapter} capabilities={{ write: true }} onSaved={reloadSignatures} /></PageBody>
  </div>;
}
